import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { ApiError } from "../client";
import { useApiClient } from "../context";
import type { components } from "../schema";

export type MemoryFragment = components["schemas"]["MemoryFragment"];

/**
 * interactive-deduction (Phase 3-3) 用の memories 取得 hook。
 * GET /playlines/{playlineId}/memories をラップし、DeductionPanel の証拠リストに使う。
 */
export function useMemories(
  playlineId: string | null,
): UseQueryResult<MemoryFragment[], ApiError> {
  const client = useApiClient();

  return useQuery<MemoryFragment[], ApiError>({
    queryKey: ["memories", playlineId],
    enabled: playlineId !== null,
    queryFn: async () => {
      if (playlineId === null) return [];
      const { data, error } = await client.GET(
        "/playlines/{playlineId}/memories",
        { params: { path: { playlineId } } },
      );
      if (error !== undefined) {
        throw new ApiError(
          typeof (error as { status?: number }).status === "number"
            ? (error as { status: number }).status
            : 0,
          error as unknown as ApiError["problem"],
        );
      }
      return data?.fragments ?? [];
    },
  });
}
